// extracted by mini-css-extract-plugin
export default {"plan":"PlanPage_plan__LeL4q"};